// extracted by mini-css-extract-plugin
export default {"list":"Inputs_list__LfwcX","item":"Inputs_item__xgiGB"};